import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/WorkOrder';
import { withRouter } from "react-router-dom";
import GPSInfo from "../GPS/GPSTable";
import GoogleMaps from "../GPS/GoogleMapsAPI";
import Breadcrumb from "../BreadcrumbMenu";
import Document from "../Document";

class WorkOrderDetail extends Component {
    constructor(props) {
        super(props);

        this.handleBack = this.handleBack.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        if (this.props.match) {
            const id = this.props.match.params.id;
            this.props.selectWorkOrder(id);
        }
    }

    handleBack() {
        this.props.history.goBack();
    }

    handleClick(event) {
        this.props.history.push("/locations/" + this.props.current.locationId);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.match && JSON.stringify(prevProps.current) !== JSON.stringify(this.props.current)) {
            const id = this.props.match.params.id;
            this.props.getWorkOrderImages(id);
        }
    }

    render() {
        if (!this.props.current) {
            return (null);
        } else {
            return (
                <div>
                    <Breadcrumb />

                    {/*Location Detail Container*/}
                    <div className="centered-container border" onClick={this.handleClick} style={{ cursor: 'pointer' }}>
                        <div className="container-body">
                            <div className="detail">
                                <div className="detail-row">
                                    <div className="row-item">
                                        <h3>{this.props.current.storeName}</h3>
                                    </div>
                                    {this.props.current.locStatus ?
                                        <div className="row-item">
                                            <div className="pill-blue">
                                                {this.props.current.locStatus}
                                            </div>
                                        </div>
                                        : ""
                                    }
                                    {this.props.current.isFlagShipStore ?
                                        <div className="row-item">
                                            <div className="pill-red">
                                                Fl
                                            </div>
                                        </div>
                                        : ""
                                    }
                                </div>
                                <div className="detail-row">
                                    <p className="label font-md">{this.props.current.street} <br />{this.props.current.city}, {this.props.current.state}</p>
                                </div>
                                <div className="detail-row">
                                    <div className="row-item">
                                        <span className="icon-person" />
                                    </div>
                                    <div className="row-item">
                                        <p className="label">{this.props.current.storeContact || '---'}</p>
                                    </div>
                                    <div className="row-item">
                                        <span className="icon-phone" />
                                    </div>
                                    <div className="row-item">
                                        <p className="label">{this.props.current.phone || '---'}</p>
                                    </div>
                                    <div className="row-item">
                                        <span className="icon-print" />
                                    </div>
                                    <div className="row-item">
                                        <p className="label">{this.props.current.fax || '---'}</p>
                                    </div>
                                    <div className="row-item">
                                        <span className="icon-email" />
                                    </div>
                                    <div className="row-item">
                                        <p className="label">{this.props.current.email || '---'} </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/*WO Detail container*/}
                    <div className="centered-container border">
                        <div className="container-body">
                            <div className="detail">

                                <div className="detail-row">
                                    <div className="row-item">
                                        <h3>{this.props.current.workOrderNumber}</h3>
                                    </div>
                                    <div className="row-item">
                                        <div className="pill-blue">
                                            {this.props.current.status}
                                        </div>
                                    </div>
                                </div>

                                <div className="detail-row">
                                    <h3>{this.props.current.serviceType} {this.props.current.workOrderType} </h3>
                                </div>

                                <div className="detail-row">
                                    <div className="row-item-lg">
                                        <p className="label">PO #</p>
                                        <p style={{ marginLeft: '8px' }}>{this.props.current.customerPO || 'N/A'}</p>
                                    </div>
                                    <div className="row-item-lg" style={{ marginLeft: '8px' }}>
                                        <p className="label">Confirmation #</p>
                                        <p style={{ marginLeft: '8px' }}>039840480</p>
                                    </div>
                                </div>

                                <hr />

                                <div className="detail-row">
                                    <div className="row-item-lg">
                                        <p className="label">Start Date</p>
                                        <p style={{ marginLeft: '8px' }}>{this.props.current.start || 'N/A'}</p>
                                    </div>
                                    <div className="row-item-lg">
                                        <p className="label">Scheduled Date</p>
                                        <p style={{ marginLeft: '8px' }}>{this.props.current.scheduled || 'N/A'}</p>
                                    </div>
                                    <div className="row-item-lg">
                                        <p className="label">Completed Date</p>
                                        <p style={{ marginLeft: '8px' }}>{this.props.current.completed || 'N/A'}</p>
                                    </div>
                                    <div className="row-item-lg">
                                        <p className="label">Due Date</p>
                                        <p style={{ marginLeft: '8px' }}>{this.props.current.due || 'N/A'}</p>
                                    </div>
                                </div>

                                <hr />

                                {this.props.current.invoiceNumber ?
                                    <div className="detail-row">
                                        {this.props.current.invoiceImage ?
                                            <div className="image-item">
                                                <a
                                                    href={`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/document${this.props.current.invoiceImage.url}`}
                                                    target='_blank' rel='noopener noreferrer'>
                                                    <Document link={this.props.current.invoiceImage.url} width='95' height='97' />
                                                </a>
                                                <p className="label" style={{ textAlign: 'center' }}>Invoice</p>
                                            </div>
                                            : ''
                                        }
                                        <div className="row-item-lg">
                                            <p className="label">Invoice #</p>
                                            <p style={{ marginLeft: '8px' }}>{this.props.current.invoiceNumber}</p>
                                        </div>
                                        <div className="row-item-lg">
                                            <p className="label">Invoice Amount</p>
                                            <p style={{ marginLeft: '8px' }}>${this.props.current.invoiceAmount}</p>
                                        </div>
                                        <div className="row-item-lg">
                                            <p className="label">Invoice Date</p>
                                            <p style={{ marginLeft: '8px' }}>{this.props.current.invoiceDate}</p>
                                        </div>
                                    </div>
                                    : ""}
                                {this.props.current.invoiceNumber ? <hr /> : ""}


                                {/*<div className="detail-row">*/}
                                {/*<div className="row-item">*/}
                                {/*<p className="label">Description</p>*/}
                                {/*<p style={{marginLeft: '8px'}}> </p>*/}
                                {/*</div>*/}
                                {/*</div>*/}

                                {/*<hr />*/}

                                <GPSInfo gpsActions={this.props.current.gpsActions} />

                                <div className="detail-row"
                                    style={{
                                        height: 250,
                                        width: '100%',
                                        display: 'flex',
                                        flexFlow: 'row nowrap',
                                        marginRight: '8px',
                                        padding: 0,
                                        position: 'relative',
                                        border: 'solid grey 1px'
                                    }}
                                >
                                    <GoogleMaps gpsActions={this.props.current.gpsActions} location={
                                        {
                                            lat: this.props.current.latitude,
                                            lng: this.props.current.longitude,
                                            name: this.props.current.storeName
                                        }} />
                                </div>

                                {this.props.current.images.length > 0 ?
                                    <div className="detail-wo-item">
                                        <hr />
                                        <div className="item-row-images">
                                            {this.props.current.images.map((image) => {
                                                return (
                                                    <div className="image-item" key={image.id}>
                                                        <a
                                                            href={`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/document${image.url}`}
                                                            target='_blank' rel='noopener noreferrer'>
                                                            <Document link={image.url} width='95' height='97' />
                                                        </a>
                                                        <p className="label" style={{ textAlign: 'center' }}>{image.name}</p>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    :
                                    ''
                                }

                            </div>
                        </div>
                    </div>
                </div>
            );
        }

    }

}

const mapStateToProps = function (state) {
    return {
        user: state.oidc.user,
        current: state.workorders.current,
    }
};

export default withRouter(connect(
    mapStateToProps,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(WorkOrderDetail));